export const profilesPages = {
  computed: {
    profilesPages() {
      return [
        {
          text: 'Indústria',
          value: 'ti',
          has_pii_access: true,
          pages: ['home'],
        },
      ]
    },
  },
}
